import { useState, useEffect, useRef } from 'react';
import { useQueryParamContext } from '../context/QueryParamContext';

export const useLocaleSwitchLoader = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { locale } = useQueryParamContext();
  const timeout = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    setIsLoading(true);

    timeout.current = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, [locale]);

  useEffect(() => {
    return () => {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    };
  }, []);

  return { isLoading };
};
